/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const dependencyEdgeSchema = z.object({
  direction: z
    .enum(['PREDECESSOR', 'SUCCESSOR'])
    .describe("Whether the related item is this item's predecessor or successor"),
  impact: z
    .enum(['NO_ISSUE', 'AT_RISK', 'BLOCKED', 'CANNOT_EVALUATE'])
    .describe("Dependency impact of this edge, rendered for this item's side of it"),
  reason: z
    .enum([
      'UNSPECIFIED',
      'PREDECESSOR_FINISHES_AFTER_START',
      'FINISH_AFTER_SUCCESSOR_START',
      'MISSING_PREDECESSOR_FINISH_DATE',
      'MISSING_START_DATE',
    ])
    .describe('Why this edge has the stated impact'),
  relatedItemId: z.int().describe('Id of the item on the other end of this edge'),
});
